import DictionaryForm from '@/modules/Dictionary/__form';
import FCheckbox from '@/plugins/form/FCheckbox';
import {
  setItemCode,
  setItemCountry,
  setItemRegion,
  setItemName,
  setItemNameLat,
} from '@/modules/Dictionary/__form/item';

export default class DictionaryCityForm extends DictionaryForm {
  static permission = {
    add: [109],
    edit: [109],
    view: [109],
    remove: [109],
  };

  dictionary = 'city';

  constructor(props = {}) {
    super(props);
    setItemCountry.bind(this)();
    setItemRegion.bind(this)();
    setItemName.bind(this)();
    setItemNameLat.bind(this)();
    setItemCode.bind(this)();
    this.setItemIsDeparture();
  }

  setItemIsDeparture() {
    this.isDeparture = new FCheckbox({
      name: 'IsDeparture',
      label: '',
      placeholder: 'Город отправления',
    });
    this.setItem('isDeparture', this.isDeparture);
  }
}
